
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import Vant from 'vant';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/Css.css'
import './assets/iconfont/iconfont.css'
import 'vant/lib/index.css';
import Moment from 'moment'

import store from './store/index.js'

import api from './axios_api/index.js'
Vue.prototype.$api = api

import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

//接口路径配置
import globalPath from './assets/script/globalPath.vue' 
Vue.prototype.API = globalPath.globalPath //接口路径配置

// 获取公司地址
import comAddress from './assets/script/comAddress.js'
Vue.prototype.$comAddress = comAddress

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Vant);

//全局方法
import common from './assets/common.js'
Vue.prototype.$common = common

Vue.prototype.moment = Moment

window.Vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js